<template>
  
  <div class="dashboard-container">
    <div class="page-title">运营驾驶舱 <small>v1.0 · 基础私域健康度总览</small></div>

    <!-- KPI 卡片 -->
    <section class="kpi-grid">
      <div class="kpi-card"  :style="{ '--accent': '#4F46E5' }">
        <div class="kpi-title">客户总数</div>
        <div class="kpi-value">{{ showcount(summaryData.data.customer_count) }}</div>
        <div class="kpi-foot">
          <span class="kpi-sub" >{{ rangeNewLabel() }}{{ showcount(summaryData.data.new_customer_count) }}</span>
          <span class="kpi-delta" :class="summaryData.data.customer_count ? getdelta(summaryData.data.customer_count).cls : ''" >
            <span>{{ summaryData.data.customer_count ? getdelta(summaryData.data.customer_count).text : '--' }}</span>
          </span>
          <span class="kpi-cmp">较上周期</span>
        </div>
      </div>
      <div class="kpi-card"  :style="{ '--accent': '#7C3AED' }">
        <div class="kpi-title">新增客户数</div>
        <div class="kpi-value">{{ showcount(summaryData.data.new_customer_count) }}</div>
        <div class="kpi-foot">
          <span class="kpi-delta" :class="summaryData.data.new_customer_count ? getdelta(summaryData.data.new_customer_count).cls : ''" >
            <span>{{ summaryData.data.new_customer_count ? getdelta(summaryData.data.new_customer_count).text : '--' }}</span>
          </span>
          <span class="kpi-cmp">较上周期</span>
        </div>
      </div>
      <div class="kpi-card"  :style="{ '--accent': '#EF4444' }">
        <div class="kpi-title">单向好友（流失）客户数</div>
        <div class="kpi-value">{{ showcount(summaryData.data.one_way_count) }}</div>
        <div class="kpi-foot">
          <span class="kpi-sub" >范围内新增流失{{ summaryData.data.one_way_count ? summaryData.data.one_way_count.change_value : 0 }}</span>
          <span class="kpi-delta" :class="summaryData.data.one_way_count ? getdelta(summaryData.data.one_way_count).cls : ''" >
            <span>{{ summaryData.data.one_way_count ? getdelta(summaryData.data.one_way_count).text : '--' }}</span>
          </span>
          <span class="kpi-cmp">较上周期</span>
        </div>
      </div>
      <div class="kpi-card"  :style="{ '--accent': '#4F46E5' }">
        <div class="kpi-title">会话量 / AI 处理率</div>
        <div class="kpi-value">{{ showcount(summaryData.data.sessions_count) }}</div>
        <div class="kpi-foot">
          <span class="kpi-delta" :class="summaryData.data.sessions_count ? getdelta(summaryData.data.sessions_count).cls : ''" >
            <span>{{ summaryData.data.sessions_count ? getdelta(summaryData.data.sessions_count).text : '--' }}</span>
          </span>
          <span class="kpi-cmp">会话较上周期</span>
          <span class="kpi-sub" >AI 处理率：<span :class="showai() !== '--' ? 'kpi-delta good' : ''">{{ showai() }}</span></span>
        </div>
      </div>
    </section>

    <!-- 主网格 -->
    <div class="main-grid">
      <!-- 趋势分析 -->
      <section class="panel trend-panel">
        <div class="panel-head">
          <div class="panel-title">趋势分析</div>
          <div class="tabs">
            <button
              class="tab"
              :class="{ active: state.view === 'customer' }"
              @click="setView('customer')"
            >客户增长</button>
            <button
              class="tab"
              :class="{ active: state.view === 'lost' }"
              @click="setView('lost')"
            >单向好友（流失）增长</button>
            <button
              class="tab"
              :class="{ active: state.view === 'session' }"
              @click="setView('session')"
            >会话量 &amp; AI处理数</button>
          </div>
        </div>
        <div class="time-filter-mini">
          <button
            class="range-btn"
            :class="{ active: state.range === 'today' }"
            @click="setRange('today')"
          >今日</button>
          <button
            class="range-btn"
            :class="{ active: state.range === '7d' }"
            @click="setRange('7d')"
          >近7天</button>
          <button
            class="range-btn"
            :class="{ active: state.range === '30d' }"
            @click="setRange('30d')"
          >近30天</button>
          <button
            class="range-btn"
            :class="{ active: state.range === 'custom' }"
            @click="setRange('custom')"
          >自定义</button>
          <span class="custom-wrap" :style="{ display: state.range === 'custom' ? 'inline-flex' : 'none' }">
            <el-date-picker
              v-model="timedata.data"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="YYYY-MM-DD"
              @change="timeDateChange"
            />
          </span>
        </div>
        <div class="chart-host">
          <div id="main" style="width: 100%;height: 274px;"></div>
        </div>
      </section>

      <!-- 实时预览/预警 -->
      <section class="panel">
        <div class="panel-head">
          <div class="panel-title">实时预览 / 预警</div>
        </div>
        <div class="realtime-grid">
          <!--  警告样式：warn -->
          <div class="rt-card">
            <!--  警告样式：warn -->
            <div class="rt-dot"  ></div>
            <div class="rt-title">在线坐席</div>
            <div class="rt-value">{{ nowdata.data.online_seat_count != null ? nowdata.data.online_seat_count : 0 }} <span class="rt-unit">个</span></div>
            <div class="rt-aux">
              接待客服 <b>{{ nowdata.data.online_agent_count != null ? nowdata.data.online_agent_count : 0 }}</b> 人 · 1 客服约接待 <b>{{ shownull(nowdata.data.seats_per_agent) }}</b> 个坐席
            </div>
          </div>
          <!--  警告样式：warn -->
          <div class="rt-card" >
            <!--  警告样式：warn -->
            <div class="rt-dot" ></div>
            <div class="rt-title">当前排队</div>
            <div class="rt-value">{{ nowdata.data.queued_session_count != null ? nowdata.data.queued_session_count : 0 }} <span class="rt-unit">人</span></div>
            <div class="rt-aux">
              会话中 <b>{{ nowdata.data.active_session_count != null ? nowdata.data.active_session_count : 0 }}</b> 人
              <!-- <template v-if="rtData.queue > rtData.queueWarn"> · 超阈值 {{ rtData.queueWarn }}，建议增援</template> -->
              <template> · 排队可控</template>
            </div>
          </div>
          <div class="rt-card">
            <div class="rt-dot"></div>
            <div class="rt-title">AI 实时接待占比</div>
            <div class="rt-value">{{ shownull(nowdata.data.ai_reception_rate) == '--' ? '--' : nowdata.data.ai_reception_rate + '%' }}</div>
            <div class="rt-aux">
              转人工率 <b>{{ shownull(nowdata.data.transfer_to_human_rate) == '--' ? '--' : nowdata.data.transfer_to_human_rate + '%' }}</b> · 本时段转人工 {{ nowdata.data.transfer_to_human_count != null ? nowdata.data.transfer_to_human_count : 0 }} 次
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 系统更新日志 -->
    <section class="changelog-panel">
      <div class="panel-head">
        <div class="panel-title">系统更新日志</div>
        <!-- <a class="log-all" href="#">查看全部 →</a> -->
      </div>
      <el-collapse  >
        <el-collapse-item title="" :name="i" v-for="(log, i) in changelogList.data"
          :key="i">
          <template #title="">
            <div class="log-head">
              <div>
                <span v-if="log.type==1" class="log-tag" style="background-color: #4F46E5;">新功能</span>
                <span v-else-if="log.type==2" class="log-tag" style="background-color: #7C3AED;">优化</span>
                <span v-else-if="log.type==3" class="log-tag" style="background-color: #F59E0B;">修复</span>
                <span v-else-if="log.type==4" class="log-tag" style="background-color: #EF4444;">安全</span>
                <span class="log-ver">v{{ log.version.replace(/^v/, '') }}</span>
                <span class="log-sum">{{ log.summary }}</span>
              </div>
              <div>
                <span class="log-date">{{ log.published_at }}</span>
              </div>
            </div>
          </template>
          <div class="log-detail" v-html="log.details"></div>
          <div class="log-mod">影响模块：{{ log.module }}</div>
        </el-collapse-item>
      </el-collapse> 
    </section>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted } from 'vue'
import * as echarts from 'echarts';
import { newchangelog, newauth, newtrends, newgetnowdata, newsummary } from '@/assets/js/common.js'

const timedata = reactive({
  data:[]
})

const timeDateChange = (val) => {
  //清空日期时不发请求，避免 timedata.data 为 null 导致报错
  if(!timedata.data || !timedata.data[0] || !timedata.data[1]){
    return
  }
  //选择自定义时间后刷新概览和趋势图
  getsummary()
  gettrends()
}



// ==================== 账号信息 ====================

const userinfo = reactive({
  data:{}
})
//获取账号信息
const getuserinfo = ()=>{
  newauth().then((response)=>{
    if(response.data.msg.code==0){
      userinfo.data = response.data.data

      //获取实时预览数据
      getnowdata()
    }
  })
}

// ==================== 更新日志 ====================

const changelogList = reactive({
  data:[]
})
//获取更新日志
const getchangelog = ()=>{
  newchangelog({
    limit:20
  }).then((response)=>{
    if(response.data.msg.code==0){
      changelogList.data = response.data.data
    }
  })
}




// ==================== 状态 ====================
const state = reactive({
  range: '30d',
  view: 'customer',
})

// ==================== 概览 ====================
const summaryData = reactive({
  data:{}
})
//值为null或字符串"null"时显示--
const shownull = (val)=>{
  if(val==null || val=='null'){
    return '--'
  }
  return val
}
//计数值未知时显示--，避免把数据缺失当成0
const showcount = (metric)=>{
  if(!metric || metric.value === null || metric.value === undefined || metric.value === '' || metric.value === 'null'){
    return '--'
  }
  return metric.value
}
//客户总数卡片的区间新增文案，跟随趋势分析的时间选择
const rangeNewLabel = ()=>{
  if(state.range=='today'){
    return '今日新增'
  }
  if(state.range=='7d'){
    return '近7天新增'
  }
  if(state.range=='30d'){
    return '近30天新增'
  }
  return '自定义新增'
}
//AI处理率显示：空值/非数字时显示--
const showai = ()=>{
  var rate = summaryData.data && summaryData.data.ai_participation_rate
  if(!rate){
    return '--'
  }
  var v = rate.value
  //null/undefined/空字符串/字符串"null"直接显示--
  if(v === null || v === undefined || v === '' || v === 'null'){
    return '--'
  }
  var n = Number(v)
  if(isNaN(n)){
    return '--'
  }
  return n + '%'
}
//计算环比变化展示（返回样式类名和文本）
const getdelta = (metric)=>{
  var cls = ''
  var text = '--'
  if(!metric){
    return {cls:cls, text:text}
  }
  //change_rate为空或非数字时显示--
  var rate = metric.change_rate
  if(rate === null || rate === undefined || rate === '' || rate === 'null' || isNaN(Number(rate))){
    return {cls:cls, text:text}
  }
  rate = Number(rate)
  if(metric.change_direction=='increase'){
    cls = 'good'
    text = '▲' + rate + '%'
  }else if(metric.change_direction=='decrease'){
    cls = 'bad'
    text = '▼' + Math.abs(rate) + '%'
  }else if(metric.change_direction=='unchanged'){
    cls = ''
    text = '持平'
  }
  return {cls:cls, text:text}
}
//请求序号：快速切换时间/视图时只采纳最后一次响应
var summarySeq = 0
var trendsSeq = 0
//获取概览数据
const getsummary = ()=>{
  var seq = ++summarySeq
  //自定义区间未选完整时不做请求，避免清空日期后报错
  if(state.range=='custom' && (!timedata.data || !timedata.data[0] || !timedata.data[1])){
    return
  }
  var params = {
    range: state.range,
    // corp_ids:[userinfo.data.id]
  }
  //自定义时间传起止日期
  if(state.range=='custom'){
    params.start_date = timedata.data[0]
    params.end_date = timedata.data[1]
  }
  newsummary(params).then((response)=>{
    if(seq !== summarySeq){
      return
    }
    if(!response || !response.data || !response.data.msg){
      return
    }
    if(response.data.msg.code==0){
      summaryData.data = response.data.data
    }
  })
}

// ==================== 趋势 ====================
const trendData = reactive({
  data:{}
})
//echarts实例
var chartInstance = null
//图表容器尺寸变化时自适应
var chartResizeObserver = null
var chartResizeFrame = null
var chartResizeHandler = null
const scheduleChartResize = ()=>{
  if(chartResizeFrame){
    cancelAnimationFrame(chartResizeFrame)
  }
  chartResizeFrame = requestAnimationFrame(()=>{
    chartResizeFrame = null
    if(chartInstance){
      chartInstance.resize()
    }
  })
}
//获取趋势数据
const gettrends = ()=>{
  var seq = ++trendsSeq
  //自定义区间未选完整时不做请求，避免清空日期后报错
  if(state.range=='custom' && (!timedata.data || !timedata.data[0] || !timedata.data[1])){
    return
  }
  var params = {
    range: state.range,
    view: state.view,
    // corp_ids:[userinfo.data.id]
  }
  //自定义时间传起止日期
  if(state.range=='custom'){
    params.start_date = timedata.data[0]
    params.end_date = timedata.data[1]
  }
  newtrends(params).then((response)=>{
    if(seq !== trendsSeq){
      return
    }
    if(!response || !response.data || !response.data.msg){
      return
    }
    if(response.data.msg.code==0){
      trendData.data = response.data.data
      renderChart()
    }
  })
}

//渲染趋势图
const renderChart = ()=>{
  if(!chartInstance){
    return
  }
  var data = trendData.data || {}
  var points = data.points || []
  var dates = []
  var s1 = []
  var s2 = []
  var s1name = ''
  var s2name = ''
  //日期轴
  dates = points.map(function(item){return item.bucket_start})
  if(state.view=='session'){
    //会话量 & AI处理数
    s1name = '会话量'
    s2name = 'AI处理数'
    s1 = points.map(function(item){return item.sessions_count != null ? item.sessions_count : null})
    s2 = points.map(function(item){return item.sessions_ai_count != null ? item.sessions_ai_count : null})
  }else if(state.view=='lost'){
    //单向好友（流失）增长
    s1name = '每日流失'
    s2name = '累积流失'
    s1 = points.map(function(item){return item.new_one_way_count != null ? item.new_one_way_count : null})
    s2 = points.map(function(item){return item.one_way_count != null ? item.one_way_count : null})
  }else{
    //客户增长
    s1name = '每日新增'
    s2name = '累积客户数'
    s1 = points.map(function(item){return item.new_customer_count != null ? item.new_customer_count : null})
    s2 = points.map(function(item){return item.customer_count != null ? item.customer_count : null})
  }
  chartInstance.setOption({
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'none'
      },
      formatter: function(params){
        if(!params || params.length==0){
          return ''
        }
        var point = points[params[0].dataIndex] || {}
        var html = params[0].axisValue
        params.forEach(function(p){
          //会话视图：折线主数据为AI处理数，AI处理率作为附带数据展示
          if(state.view=='session' && p.seriesIndex==1){
            var sessions = point.sessions_count
            var ai = point.sessions_ai_count
            var rate = sessions != null && sessions > 0 && ai != null
              ? (ai / sessions * 100).toFixed(1) + '%'
              : '--'
            html += '<br/>' + p.marker + 'AI处理数：' + (ai != null ? ai : '--') + '（AI处理率：' + rate + '）'
          }else if(p.value === null || p.value === undefined || p.value === '-'){
            //缺失数据不展示为0
            html += '<br/>' + p.marker + p.seriesName + '：--'
          }else{
            html += '<br/>' + p.marker + p.seriesName + '：' + p.value
          }
        })
        //数据质量提示：0缺失，2为回填估算值
        var qualityText = ''
        if(state.view=='session'){
          if(point.session_data_quality === 0 || point.ai_data_quality === 0){
            qualityText = '数据缺失或不完整'
          }
        }else if(point.data_quality === 0){
          qualityText = '数据缺失'
        }else if(point.data_quality === 2){
          qualityText = '估算值'
        }
        if(qualityText){
          html += '<br/><span style="color:#94A3B8">' + qualityText + '</span>'
        }
        return html
      }
    },
    // legend: {
    //   data: [s1name, s2name]
    // },
    grid: {
      left: 0,
      right: 0,
      top: 20,
      bottom: 10,
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: dates,
        axisPointer: {
          type: 'shadow'
        },
        axisLine: {
          lineStyle: {
            color: '#E8ECF3'
          }
        },
        axisLabel: {
          color: '#64748B'
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '',
        min: 0,
        axisLabel: {
          color: '#64748B'
        },
        splitLine: {
          lineStyle: {
            color: '#EEF1F6',
            type: 'dashed'
          }
        }
      },
      {
        type: 'value',
        name: '',
        min: 0,
        show: false,
        axisLabel: {
          color: '#64748B'
        },
        splitLine: {
          show: false
        }
      }
    ],
    series: [
      {
        name: s1name,
        type: 'bar',
        barWidth: '60%',
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: 'rgba(165, 180, 252, 0.9)' },
            { offset: 1, color: 'rgba(165, 180, 252, 0.9)' }
          ]),
          borderRadius: [6, 6, 0, 0]
        },
        data: s1
      },
      {
        name: s2name,
        type: 'line',
        yAxisIndex: 0,
        smooth: false,
        symbol: 'circle',
        symbolSize: 6,
        lineStyle: {
          color: '#4F46E5',
          width: 2.5,
          shadowColor: 'rgba(79, 70, 229, 0.15)',
          shadowBlur: 8,
          shadowOffsetY: 4
        },
        itemStyle: {
          color: '#4F46E5',
          borderColor: '#fff',
          borderWidth: 2
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: 'rgba(79, 70, 229, 0.25)' },
            { offset: 1, color: 'rgba(79, 70, 229, 0.02)' }
          ])
        },
        data: s2
      }
    ]
  })
}

function setRange(range) {
  state.range = range
  var StartTime = ''
  var EndTime = ''
  if(range=='custom'){
    //自定义时若时间框为空，默认填近30天
    if(!timedata.data || timedata.data.length==0){
      StartTime = new Date(new Date().setDate(new Date().getDate() - 29))
      EndTime = new Date()
      timedata.data = [getCurrentTime(StartTime), getCurrentTime(EndTime)]
    }
  }else{
    if(range=='today'){
      StartTime = new Date()
      EndTime = new Date()
    }else if(range=='7d'){
      StartTime = new Date(new Date().setDate(new Date().getDate() - 6))
      EndTime = new Date()
    }else if(range=='30d'){
      StartTime = new Date(new Date().setDate(new Date().getDate() - 29))
      EndTime = new Date()
    }
    timedata.data = [getCurrentTime(StartTime), getCurrentTime(EndTime)]
  }
  //切换时间范围刷新概览和趋势
  getsummary()
  gettrends()
}

function setView(view) {
  state.view = view
  //切换视图刷新趋势图
  gettrends()
}



// ==================== 生命周期 ====================
onMounted(() => {

  //获取账号信息
  getuserinfo()
  //获取更新日志
  getchangelog()
  //获取概览数据
  getsummary()

  // 基于准备好的dom，初始化echarts实例
  var chartHost = document.getElementById('main')
  chartInstance = echarts.init(chartHost)
  //监听容器尺寸变化（含F12、窗口缩放、侧边栏变化）
  if(typeof ResizeObserver !== 'undefined'){
    chartResizeObserver = new ResizeObserver(scheduleChartResize)
    chartResizeObserver.observe(chartHost)
  }else{
    chartResizeHandler = scheduleChartResize
    window.addEventListener('resize', chartResizeHandler)
  }
  //获取趋势数据并渲染图表
  gettrends()
})

onUnmounted(() => {
  summarySeq++
  trendsSeq++
  if(chartResizeObserver){
    chartResizeObserver.disconnect()
    chartResizeObserver = null
  }
  if(chartResizeHandler){
    window.removeEventListener('resize', chartResizeHandler)
    chartResizeHandler = null
  }
  if(chartResizeFrame){
    cancelAnimationFrame(chartResizeFrame)
    chartResizeFrame = null
  }
  if(chartInstance){
    chartInstance.dispose()
    chartInstance = null
  }
})

//获取实时预览数据
const nowdata = reactive({
  data:[]
})
//获取实时预览数据
const getnowdata = () => {
   
  newgetnowdata({
    // corp_ids:[userinfo.data.id]
  }).then((response)=>{
    if(response.data.msg.code==0){
      console.log('获取实时预览数据')
      console.log(response.data.data)
      nowdata.data = response.data.data
    }
  })
}



//中国标准时间转化
const getCurrentTime = (date) => {
  // let date = new Date()
  var year = date.getFullYear() //返回指定日期的年份
  var month = repair(date.getMonth() + 1);//月
  var day = repair(date.getDate());//日
  var hour = repair(date.getHours());//时
  var minute = repair(date.getMinutes());//分
  var second = repair(date.getSeconds());//秒
  
  //当前时间 
  var curTime = year + "-" + month + "-" + day;
  // var curTime = year + "-" + month + "-" + day
  //     + " " + hour + ":" + minute + ":" + second;
  // console.log(curTime)
  //返回 2022-11-25 11:23:26
  return curTime;
}
//补0
const repair = (i) => {
  if (i >= 0 && i <= 9) {
    return "0" + i;
  } else {
    return i;
  }
}
</script>

<style scoped>
.dashboard-container {
  background: #F7F8FC;
  min-height: 100%;
  padding: 22px 24px 40px;
}

.page-title {
  font-size: 20px;
  font-weight: 800;
  margin: 4px 0 18px;
  color: #1E293B;
}

.page-title small {
  font-weight: 500;
  color: #64748B;
  font-size: 13px;
  margin-left: 10px;
}

/* KPI */
.kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 18px;
}

.kpi-card {
  position: relative;
  background: #ffffff;
  border-radius: 14px;
  padding: 16px 18px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .06);
  overflow: hidden;
}

.kpi-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: var(--accent);
}

.kpi-title {
  color: #64748B;
  font-size: 13px;
  font-weight: 600;
}

.kpi-value {
  font-size: 28px;
  font-weight: 800;
  margin: 8px 0 6px;
  letter-spacing: .5px;
  color: #1E293B;
}

.kpi-foot {
  font-size: 12px;
  color: #64748B;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.kpi-sub {
  color: #1E293B;
  font-weight: 600;
}

.kpi-cmp {
  color: #64748B;
}

.kpi-delta {
  font-weight: 700;
}

.kpi-delta.good {
  color: #10B981;
}

.kpi-delta.bad {
  color: #EF4444;
}

/* 主网格 */
.main-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.9fr) minmax(0, 1fr);
  gap: 16px;
  margin-bottom: 18px;
}

.panel {
  min-width: 0;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .06);
  padding: 18px;
}

.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 10px;
  flex-wrap: wrap;
}

.panel-title {
  font-size: 15px;
  font-weight: 700;
  color: #1E293B;
}

/* 趋势 */
.trend-panel {
  position: relative;
}

.time-filter-mini {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  background: #F1F3F9;
  border-radius: 10px;
  padding: 3px;
  margin-bottom: 14px;
}

.range-btn {
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 600;
  color: #64748B;
}

.range-btn:hover {
  color: #1E293B;
}

.range-btn.active {
  background: linear-gradient(90deg, #4F46E5, #7C3AED);
  color: #fff;
}

.custom-wrap {
  align-items: center;
  gap: 6px;
  margin-left: 4px;
}
.custom-wrap  :deep(.el-input__wrapper){
  background-color: #F1F3F9;
  box-shadow: none;
  height: auto;
}
.custom-wrap  :deep(.el-range-separator){
  font-size: 12.5px;
}
.custom-wrap  :deep(.el-range-input){
  font-size: 12.5px;
}
.custom-wrap input {
  border: 1px solid #E8ECF3;
  border-radius: 8px;
  padding: 5px 8px;
  font-size: 12px;
  color: #1E293B;
}

.custom-wrap span {
  color: #64748B;
  font-size: 12px;
}

.tabs {
  display: inline-flex;
  gap: 2px;
  background: #F1F3F9;
  border-radius: 10px;
  padding: 3px;
}

.tab {
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 600;
  color: #64748B;
}

.tab:hover {
  color: #1E293B;
}

.tab.active {
  background: #fff;
  color: #4F46E5;
  box-shadow: 0 1px 2px rgba(0,0,0,.08);
}

.chart-host {
  width: 100%;
  min-width: 0;
  position: relative;
  padding: 0;
  margin: 0;
}

.chart-svg {
  width: 100%;
  height: auto;
  display: block;
}

.ax-l, .ax-r, .ax-x {
  fill: #64748B;
  font-size: 11px;
}

.chart-tip {
  position: absolute;
  pointer-events: none;
  background: #1E293B;
  color: #fff;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 12px;
  box-shadow: 0 8px 24px rgba(15,23,42,.25);
  z-index: 10;
  min-width: 150px;
}

.tip-h {
  font-weight: 700;
  margin-bottom: 6px;
  opacity: .9;
}

.tip-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 3px 0;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

/* 实时 */
.realtime-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rt-card {
  min-width: 0;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto auto;
  column-gap: 12px;
  border: 1px solid #E8ECF3;
  border-radius: 12px;
  padding: 14px 16px;
  position: relative;
}

.rt-card.warn {
  border-color: rgba(239,68,68,.4);
  background: rgba(239,68,68,.04);
}

.rt-dot {
  grid-row: 1 / 4;
  align-self: center;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #10B981;
  box-shadow: 0 0 0 4px rgba(16,185,129,.15);
}

.rt-dot.warn {
  background: #EF4444;
  box-shadow: 0 0 0 4px rgba(239,68,68,.15);
  animation: pulse 1.4s infinite;
}

@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(239,68,68,.35); }
  70% { box-shadow: 0 0 0 8px rgba(239,68,68,0); }
  100% { box-shadow: 0 0 0 0 rgba(239,68,68,0); }
}

.rt-title {
  font-size: 13px;
  color: #64748B;
  font-weight: 600;
}

.rt-value {
  font-size: 26px;
  font-weight: 800;
  line-height: 1.2;
  color: #1E293B;
}

.rt-unit {
  font-size: 13px;
  font-weight: 600;
  color: #64748B;
}

.rt-aux {
  grid-column: 2;
  font-size: 12.5px;
  color: #64748B;
  margin-top: 3px;
}

.rt-aux b {
  color: #1E293B;
  font-weight: 700;
}

.rt-card.warn .rt-aux {
  color: #EF4444;
}

.rt-card.warn .rt-aux b {
  color: #EF4444;
}

/* 更新日志 */
.changelog-panel {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .06);
  padding: 18px;
}

.log-all {
  font-size: 13px;
  color: #4F46E5;
  font-weight: 600;
  text-decoration: none;
}

.log-all:hover {
  text-decoration: underline;
}

.log-item {
  border-bottom: 1px solid #E8ECF3;
  cursor: pointer;
}

.log-item:last-child {
  border-bottom: 0;
}

.log-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 4px;
  justify-content: space-between;
  width: 100%;
}

.log-tag {
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  padding: 5px 9px;
  border-radius: 999px;
  white-space: nowrap;
  line-height: 22px;
  text-align: center;
  margin-right: 8px;
}

.log-ver {
  font-weight: 800;
  font-size: 13px;
  color: #1E293B;
  white-space: nowrap;
  margin-right: 8px;
}

.log-sum {
  flex: 1;
  font-size: 13.5px;
  color: #1E293B;
}

.log-date {
  font-size: 12px;
  color: #64748B;
  white-space: nowrap;
}

.log-caret {
  color: #64748B;
  transition: transform .2s;
  font-size: 12px;
}

.log-item.open .log-caret {
  transform: rotate(180deg);
}

.log-body {
  overflow: hidden;
  transition: max-height .25s ease;
}

.log-body ul {
  margin: 0 0 8px 4px;
  padding: 0 0 0 18px;
}

.log-body li {
  font-size: 13px;
  color: #64748B;
  margin: 4px 0;
}
.log-detail {
  font-size: 13px;
  color: #64748B;
  margin: 4px 0;
  padding-left: 4px;
}
.log-mod {
  font-size: 12px;
  color: #4F46E5;
  font-weight: 600;
  padding: 0 0 0px 4px;
}

/* 响应式 */
@media (max-width: 980px) {
  .main-grid {
    grid-template-columns: 1fr;
  }
  .kpi-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .kpi-grid {
    grid-template-columns: 1fr;
  }
}
</style>
